import { InjectionToken } from '@angular/core';

export const ROOT_FOLDER = new InjectionToken<string>('rootFolder');

export interface IARMTemplateOptions {
    excludeTriggers?: boolean;
}

export const ARM_TEMPLATE_OPTIONS = new InjectionToken<IARMTemplateOptions>('armTemplateOptions');
